import "./Certification.css";

function CertificationCard({ image, title, credentialUrl }) {
  const backend = process.env.REACT_APP_BACKEND_LINK;
  const imgSrc  = image
    ? image.startsWith("http") ? image : `${backend.replace(/\/$/, "")}${image}`
    : null;

  const inner = (
    <div className="cert-card">
      {imgSrc ? (
        <img src={imgSrc} alt={title || "certificate"} className="cert-card__image" />
      ) : (
        <div className="cert-card__empty">{title || "Certificate"}</div>
      )}
    </div>
  );

  return credentialUrl ? (
    <a href={credentialUrl} target="_blank" rel="noreferrer" style={{ display: "contents" }}>
      {inner}
    </a>
  ) : inner;
}

export default CertificationCard;
